module.exports = __webpack_public_path__ + "static/media/fruit-3247447_1920.7634399f.jpg";